export const ChargebackFileTypeEnum = {
  VerifiRdr: 'verifiRdr',
  VerifiOi: 'verifiOi',
};
